import React, { FC } from 'react';
import { Controller } from 'react-hook-form';
import classNames from 'classnames';
import { ComboBox, FormControl } from '@fiverr-private/orca';
import { translate as t } from '@fiverr-private/i18n-react';
import { Text } from '@fiverr-private/typography';
import { T_FORM_KEY } from '../../utils';
import { FieldComponentProps } from '../../shared/types';
import { comboBoxError, comboBoxStyle } from '../../shared/styles.ve.css';
import { titles } from './defaults';

const TitleField: FC<FieldComponentProps> = ({ control, errors }) => (
    <FormControl label={t(`${T_FORM_KEY}.fields.title.label`)}>
        <Controller
            name="title"
            control={control}
            rules={{
                required: { value: true, message: t(`${T_FORM_KEY}.fields.title.required_error`) },
                pattern: {
                    value: /^[a-zA-Z0-9'"&();:,|\s]+$/gu,
                    message: t(`${T_FORM_KEY}.supported_characters_error`),
                },
                minLength: {
                    value: 3,
                    message: t(`${T_FORM_KEY}.minimum_letters_error`),
                },
            }}
            render={({ field: { onChange, value: title, name } }) => (
                <ComboBox
                    menuShouldBlockScroll
                    id={name}
                    className={classNames(comboBoxStyle, { [comboBoxError]: errors?.title })}
                    placeholder={t(`${T_FORM_KEY}.fields.title.placeholder`)}
                    isMulti={false}
                    isCreatable
                    options={titles.map((title) => ({ label: title, value: title }))}
                    noOptionsHide
                    onChange={({ value }) => onChange(value)}
                    value={title && { label: title, value: title }}
                    formatCreateLabel={(inputValue) => inputValue}
                />
            )}
        />
        <Text color="validationError" marginTop="2" hidden={!errors?.title}>
            {errors?.title?.message}
        </Text>
    </FormControl>
);

export default TitleField;
